export default {"src":"/_next/static/media/quote.c856ffcb.svg","height":48,"width":61};